import { Permission } from '@carm/_core';
import { createAction, props } from '@ngrx/store';
import { RoleTypes } from '../../../_core/access-control-mgt/models/user-role.model';


export const loadPermissions = createAction(
  '[Permission] Load Permissions',
);

export const loadPermissionsSuccess = createAction(
  '[Permission] Load Permssions Success',
   props<{ data: Permission[] }>(),
);

export const loadPermissionsFailure = createAction(
  '[Permission] Load Permssions Failure',
  props<{ error: any }>(),
);

export const loadNativeBusinessPermissions = createAction(
  '[Permission] Load NativeBusiness Permissions',
   props<{ data: {businessId: string} }>(),
);

export const loadNativeBusinessPermissionsSuccess = createAction(
  '[Permission] Load NativeBusiness Permssions Success',
   props<{ data: any }>(),
);

export const loadNativeBusinessPermissionsFailure = createAction(
  '[Permission] Load NativeBusiness Permssions Failure',
  props<{ error: any }>(),
);

// remove
export const loadRoleTypePermissions = createAction(
  '[RoleType Permission] Load RoleType Permissions',
    props<{ data: RoleTypes }>(),
);
// remove
export const loadRoleTypePermissionsSuccess = createAction(
  '[RoleType Permission] Load RoleType Permssions Success',
   props<{ data: any }>(),
);
// remove
export const loadRoleTypePermissionsFailure = createAction(
  '[RoleType Permission] Load RoleType Permssions Failure',
  props<{ error: any }>(),
);

export const clearPermissions = createAction(
  '[RoleType Permission] Clear Permissions'
);
